import React from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import BaseModal from './BaseModal';
import classes from './SubCancelModal.module.scss'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import subscribeStore from './subscribeStore';
import { runInAction } from 'mobx'
import dayjs from 'dayjs'


const CancellationSuccess = observer(({onClose, nextTime}) => {
  return <div className={classes.success}>
    <CheckCircleOutlineIcon className={classes.icon} />
    <div className={classes.text}>Cancellation confirmed</div>
    <div className={classes.text}>All reaming credits will expire on {nextTime}.</div>
    <Button className={classes.browseAction} variant="contained" disableElevation onClick={onClose}>Got it</Button>
  </div>
})

const CancelConfirm = observer(({onClose, onOK, nextTime, loading}) => {
  return <div className={classes.confirm}>
    <h2>Are you sure you want to cancel?</h2>
    <div className={classes.text}>You’ll lose all remaing credits and access to DrumNet on {nextTime} if you cancel.</div>
    <div className={classes.actions}>
    <Button className={classes.action} variant="outlined" disableElevation onClick={onClose} disabled={loading}>Back</Button>
    <LoadingButton className={classes.action} variant="contained" disableElevation onClick={onOK} loading={loading}>Cancel plan</LoadingButton>
    </div>
  </div>
})


const SubCancelModal = observer(({open, onClose}) => {
  const { currentSub, cancelPlan, reloadSubStatus} = subscribeStore;
  const model = useLocalObservable(() => ({
    success: false,
    loading: false,
    nextTime: dayjs(currentSub?.subscription?.billing_info?.next_billing_time).format('MMMM D YYYY'),
    async doCancel() {
      this.loading = true
      try {
        await cancelPlan()
        // await reloadSubStatus()
        runInAction(() => this.success = true)
      } catch (e) {
        console.error(e)
      } finally {
        runInAction(() => this.loading = false)
      }
    },
    async onClose() {
      try {
        if (this.success) {
          reloadSubStatus()
        }
        onClose()
      } catch (e) {
        console.error(e)
      }
    }
  }))
  // const nextTime = dayjs(currentSub?.subscription?.billing_info?.next_billing_time).format('MMMM D YYYY')

  return <BaseModal open={open} onClose={model.onClose} classes={classes}>
    {model.success ? <CancellationSuccess onClose={model.onClose} nextTime={model.nextTime} /> :
    <CancelConfirm onClose={model.onClose} onOK={model.doCancel} nextTime={model.nextTime} loading={model.loading} />}
  </BaseModal>
})

export default SubCancelModal;